/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides, tips, and insights for getting the most out of Toolverse tools.`)
};

const es_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guías, consejos e información para aprovechar al máximo las herramientas de Toolverse.`)
};

const de_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitfäden, Tipps und Einblicke, um das Beste aus Toolverse-Tools herauszuholen.`)
};

const nl_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handleidingen, tips en inzichten om het meeste uit Toolverse-tools te halen.`)
};

const fr_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides, astuces et informations pour tirer le meilleur parti des outils Toolverse.`)
};

const it_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide, consigli e approfondimenti per ottenere il massimo dagli strumenti Toolverse.`)
};

const pt_br2_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guias, dicas e insights para aproveitar ao máximo as ferramentas do Toolverse.`)
};

const pt_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guias, dicas e informações para tirar o máximo partido das ferramentas Toolverse.`)
};

const ja_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverseツールを最大限に活用するためのガイド、ヒント、洞察。`)
};

const zh_tool_blog_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指南、技巧和见解，帮助您充分利用 Toolverse 工具。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tool_blog_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tool_blog_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tool_blog_description", locale)
	if (locale === "en") return en_tool_blog_description(inputs)
	if (locale === "es") return es_tool_blog_description(inputs)
	if (locale === "de") return de_tool_blog_description(inputs)
	if (locale === "nl") return nl_tool_blog_description(inputs)
	if (locale === "fr") return fr_tool_blog_description(inputs)
	if (locale === "it") return it_tool_blog_description(inputs)
	if (locale === "pt-BR") return pt_br2_tool_blog_description(inputs)
	if (locale === "pt") return pt_tool_blog_description(inputs)
	if (locale === "ja") return ja_tool_blog_description(inputs)
	return zh_tool_blog_description(inputs)
};